import React, { useEffect, useState } from "react";
import { Reveal } from "./Motion";
import { getBundle } from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export const BundleSection = () => {
  const [b, setB] = useState(null);
  const [teeSize, setTeeSize] = useState("");
  const [jortsSize, setJortsSize] = useState("");
  const { addItem } = useCart();

  useEffect(() => { getBundle().then(setB).catch(() => {}); }, []);
  if (!b) return null;

  const add = () => {
    if (!teeSize || !jortsSize) { toast.error("Pick a size for both pieces"); return; }
    addItem(
      { id: b.id, name: b.name, price: b.price, front_image: b.image, lookup_key: b.lookup_key, preorder: b.preorder },
      `Tee ${teeSize} · Jorts ${jortsSize}`,
      1
    );
    toast.success("First Drop Bundle added to bag");
  };

  const SizeRow = ({ label, sizes, value, onChange, prefix }) => (
    <div>
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">{label}</span>
      <div className="flex flex-wrap gap-2 mt-2">
        {sizes.map((s) => (
          <button key={s} onClick={() => onChange(s)} data-testid={`bundle-${prefix}-${s}`}
            className={`min-w-[46px] h-10 px-2 border font-mono text-sm transition-colors duration-200 ${value === s ? "bg-cream text-bg border-cream" : "border-line hover:border-cream"}`}>
            {s}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <section className="max-w-[1100px] mx-auto px-4 sm:px-8 py-14 sm:py-20" data-testid="bundle-section">
      <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 items-center border border-line">
        <Reveal className="relative aspect-[4/3] sm:aspect-[4/5] overflow-hidden bg-charcoal">
          <img src={b.image} alt={b.name} className="w-full h-full object-cover" />
          {b.limited && (
            <span className="absolute top-3 left-3 bg-cs-yellow text-bg font-mono text-[9px] uppercase tracking-[0.2em] px-2.5 py-1" data-testid="bundle-limited-badge">
              Early-bird · Limited
            </span>
          )}
        </Reveal>

        <Reveal delay={0.1} className="p-6 sm:p-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-graytx">Save $10 · Bundle</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl uppercase leading-[0.9] mt-3">{b.name}</h2>
          <p className="text-graytx text-sm mt-3 leading-relaxed max-w-md">{b.details}</p>

          <div className="flex items-baseline gap-3 mt-5">
            <span className="font-mono text-2xl">${b.price.toFixed(0)}</span>
            <span className="font-mono text-base text-graytx line-through">${b.compare_at.toFixed(0)}</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-cs-green">9% off</span>
          </div>

          <div className="mt-6 space-y-4">
            <SizeRow label="Tee size" sizes={b.tee_sizes} value={teeSize} onChange={setTeeSize} prefix="tee" />
            <SizeRow label="Jorts size" sizes={b.jorts_sizes} value={jortsSize} onChange={setJortsSize} prefix="jorts" />
          </div>

          <button onClick={add} data-testid="bundle-add-btn"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-cream text-bg font-mono text-[11px] uppercase tracking-[0.2em] py-3.5 hover:bg-cs-yellow transition-colors duration-200">
            Pre-order the Bundle — ${b.price.toFixed(0)} <ArrowRight size={14} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
